/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Reduce_SelectionInputs */

const es_components_file_tree_reduce_selection = /** @type {(inputs: Components_File_Tree_Reduce_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduce la selección para continuar`)
};

const en_components_file_tree_reduce_selection = /** @type {(inputs: Components_File_Tree_Reduce_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduce selection to continue`)
};

/**
* | output |
* | --- |
* | "Reduce selection to continue" |
*
* @param {Components_File_Tree_Reduce_SelectionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_reduce_selection = /** @type {((inputs?: Components_File_Tree_Reduce_SelectionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Reduce_SelectionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_reduce_selection(inputs)
	return en_components_file_tree_reduce_selection(inputs)
});
export { components_file_tree_reduce_selection as "components.file_tree.reduce_selection" }